export default __webpack_public_path__ + "static/media/check-all.45bd0b89.svg";